import Vue from "vue";
import FAddField from "./FAddField.vue";
import FTemplate from "./FTemplate.vue";
import FWidget from "./widget/FWidget.vue";

/* Create Global components so we can access them
    in recursive components ie SectionWidget needs FWidget
 */

Vue.component("FAddField", FAddField);
Vue.component("FTemplate", FTemplate);
Vue.component("FWidget", FWidget);
